import styles from "../AudioRecorder.module.scss";

const RecordingDescription = ({ isPaused, appointment, recordingError }) => {
  if (recordingError) {
    return (
      <div className={styles["audio-recorder__recording-error"]}>
        <div>A problem has occurred, please contact support</div>
        <div>{recordingError.toString()}</div>
      </div>
    );
  }

  if (isPaused) {
    return (
      <div className={styles["audio-recorder__recording-description"]}>
        While the microphone is muted, audio will not be recorded or included in
        the AI summary after the session ends
      </div>
    );
  }

  if (appointment?.session_recording_type === "dictation") {
    return (
      <div className={styles["audio-recorder__recording-description"]}>
        <div>Ideal length is 3-6 minutes</div>
        <div>Speak slowly</div>
      </div>
    );
  }

  return (
    <div className={styles["audio-recorder__recording-description"]}>
      Orchid will generate AI-based notes and session review after your session.
    </div>
  );
};
export default RecordingDescription;
